/* unplugin-vue-components disabled */import script from "./IOSWebApp.vue?vue&type=script&setup=true&lang=js"
export * from "./IOSWebApp.vue?vue&type=script&setup=true&lang=js"

import "./IOSWebApp.vue?vue&type=style&index=0&id=126137a2&lang=less"

const __exports__ = script;

export default __exports__